import React, { useState } from 'react';
import './Portfolio.css';

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: "Modern Villa",
      category: "architecture",
      description: "Contemporary residential design with clean lines and open spaces."
    },
    {
      id: 2,
      title: "Urban Apartment",
      category: "interior",
      description: "Sophisticated interior design for a downtown apartment."
    },
    {
      id: 3,
      title: "Office Complex",
      category: "architecture",
      description: "Commercial building design focused on sustainability."
    },
    {
      id: 4,
      title: "Luxury Penthouse",
      category: "interior",
      description: "High-end interior design with custom furnishings."
    },
    {
      id: 5,
      title: "Eco House",
      category: "architecture",
      description: "Sustainable residential architecture with green technologies."
    },
    {
      id: 6,
      title: "Restaurant Design",
      category: "interior",
      description: "Contemporary restaurant interior with warm ambiance."
    }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <section id="portfolio" className="section portfolio">
      <div className="container">
        <div className="portfolio-header">
          <h2 className="section-title">Our Portfolio</h2>
          <p className="section-subtitle">
            Explore our latest projects showcasing innovative design and exceptional craftsmanship.
          </p>
        </div>

        <div className="portfolio-filters">
          <button 
            className={activeFilter === 'all' ? 'active' : ''}
            onClick={() => setActiveFilter('all')}
          >
            All Projects
          </button>
          <button 
            className={activeFilter === 'architecture' ? 'active' : ''}
            onClick={() => setActiveFilter('architecture')}
          >
            Architecture
          </button>
          <button 
            className={activeFilter === 'interior' ? 'active' : ''}
            onClick={() => setActiveFilter('interior')}
          >
            Interior Design
          </button>
        </div>

        <div className="portfolio-grid">
          {filteredProjects.map(project => (
            <div key={project.id} className="portfolio-item">
              <div className="portfolio-image">
                <div 
                  className="image-placeholder"
                  style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/project${project.id}.jpg)`
                  }}
                >
                  <div className="placeholder-overlay">
                    <h4>{project.title}</h4>
                    <p>{project.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
